import { ROUTES } from '../../../lib/routes'

/**
 * Constants related to the web register application itself.
 *
 * @module webregister.constants.WEB_REGISTER
 */
const WEB_REGISTER = {
  // This value is transformed at build time using 'envify'. See gulp/partial-tasks/rollup.js
  // and lib/getClientVersion.js
  CLIENT_VERSION: process.env.CLIENT_VERSION,

  APPLICATION_NAME: 'web_register',

  DISPLAY_NAME: 'Web Register',

  URL: ROUTES.WEB_REGISTER + '/',

  CONTACT_SUPPORT_URL:
    'https://support.vendhq.com/hc/en-us/requests/new?ticket_form_id=1375',

  VEND_STATUS_URL: 'http://status.vendhq.com/',

  // These values are transformed at build time using '@rollup/plugin-replace'. See gulp/partial-tasks/rollup.js
  VEND_URI: process.env.VEND_URI,

  LS_URI: process.env.LS_URI,
}

export { WEB_REGISTER }
